import { Component, inject } from '@angular/core';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { AuthenticatedAtlasComponent } from './authenticated-atlas/authenticated-atlas.component';
import { AtlasLoadingSkeletonComponent } from '../../organisms/atlas-loading-skeleton/atlas-loading-skeleton.component';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { ConfirmationService } from 'primeng/api';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-atlas',
  standalone: true,
  imports: [AuthenticatedAtlasComponent, AtlasLoadingSkeletonComponent],
  templateUrl: './atlas.component.html',
  styleUrl: './atlas.component.scss',
})
export class AtlasComponent {
  readonly userStore = inject(ActiveUserStore);
  readonly globalsStore = inject(GlobalsStore);

  constructor(protected sidebarService: SidebarService) {}
}
